import { Chip, Stack, Typography, Box } from "@mui/material";
import React from "react";
import { SectionLabel } from "./_wizardUi";

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <Stack direction="row" spacing={2} sx={{ py: 0.75 }}>
      <Typography
        sx={{ width: 140, flexShrink: 0, fontSize: 13, color: "text.secondary" }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: 13.5, fontWeight: 600, wordBreak: "break-all" }}>
        {value || "—"}
      </Typography>
    </Stack>
  );
}

function SuiteReview({ suite, gitUrl, branch, analyzeResult, selectedCases }) {
  const frameworks = Object.keys(analyzeResult || {});
  const countCasesInStructure = (structure) => {
    if (!structure || typeof structure !== "object") return 0;
    let casesCount = 0;
    if (structure.cases) casesCount += Object.keys(structure.cases).length;
    for (const [key, value] of Object.entries(structure)) {
      if (key !== "cases" && typeof value === "object") {
        casesCount += countCasesInStructure(value);
      }
    }
    return casesCount;
  };
  const countSelectedCasesByFramework = (framework) => {
    const items = selectedCases.filter((id) => id.startsWith(`-${framework}`));
    return items.length;
  };
  const totalSelected = (selectedCases || []).length;

  return (
    <Box>
      <Typography sx={{ fontWeight: 800, fontSize: 18, mb: 0.5 }}>
        Review &amp; submit
      </Typography>
      <Typography color="text.secondary" sx={{ fontSize: 13, mb: 2 }}>
        Confirm the suite details below, then submit to queue the selected
        cases.
      </Typography>

      <SectionLabel>Suite</SectionLabel>
      <Box sx={{ mb: 2 }}>
        <Row label="Title" value={suite?.title} />
        <Row
          label="Planned start"
          value={
            suite?.planed_start
              ? new Date(suite.planed_start).toLocaleString()
              : "Immediately"
          }
        />
        <Row label="Repository" value={gitUrl} />
        <Row label="Branch / tag" value={branch} />
      </Box>

      <SectionLabel>Selected cases ({totalSelected})</SectionLabel>
      {frameworks.length > 0 ? (
        <Stack spacing={1}>
          {frameworks.map((fw) => (
            <Stack key={fw} direction="row" alignItems="center" spacing={1.5}>
              <Chip
                label={fw}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ textTransform: "uppercase", fontWeight: 700 }}
              />
              <Typography sx={{ fontSize: 13 }}>
                {countSelectedCasesByFramework(fw)} of{" "}
                {countCasesInStructure(analyzeResult[fw]?.structure)} selected
              </Typography>
            </Stack>
          ))}
        </Stack>
      ) : (
        <Typography color="text.secondary" sx={{ fontSize: 13 }}>
          No cases discovered yet.
        </Typography>
      )}
    </Box>
  );
}

export default SuiteReview;
